function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// kapigen version 0.1.12
// tslint:disable
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
export var AdminAllowlistEntityRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.entityType) {
            wireFormat.entityType = KaggleEntityTypeWireFormat3.toJson(message.entityType);
        }
        return wireFormat;
    }
};
export var SetReportedDismissalRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.entityType) {
            wireFormat.entityType = KaggleEntityTypeWireFormat3.toJson(message.entityType);
        }
        if (message === null || message === void 0 ? void 0 : message.dismissalType) {
            wireFormat.dismissalType = ReportedDismissalTypeWireFormat3.toJson(message.dismissalType);
        }
        return wireFormat;
    }
};
export var KaggleEntityType;
(function(KaggleEntityType) {
    KaggleEntityType["UNSPECIFIED"] = "unspecified";
    KaggleEntityType["USER"] = "user";
    KaggleEntityType["FORUM_MESSAGE"] = "forumMessage";
    KaggleEntityType["FORUM_TOPIC"] = "forumTopic";
    KaggleEntityType["COMPETITION"] = "competition";
    KaggleEntityType["NOTEBOOK"] = "notebook";
    KaggleEntityType["DATASETS"] = "datasets";
    KaggleEntityType["TEAM"] = "team";
    KaggleEntityType["ORGANIZATION"] = "organization";
})(KaggleEntityType || (KaggleEntityType = {}));
export var KaggleEntityTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case KaggleEntityType.UNSPECIFIED:
            case 0:
            default:
                return "KAGGLE_ENTITY_TYPE_UNSPECIFIED";
            case KaggleEntityType.USER:
            case 1:
                return "USER";
            case KaggleEntityType.FORUM_MESSAGE:
            case 2:
                return "FORUM_MESSAGE";
            case KaggleEntityType.FORUM_TOPIC:
            case 3:
                return "FORUM_TOPIC";
            case KaggleEntityType.COMPETITION:
            case 4:
                return "COMPETITION";
            case KaggleEntityType.NOTEBOOK:
            case 5:
                return "NOTEBOOK";
            case KaggleEntityType.DATASETS:
            case 6:
                return "DATASETS";
            case KaggleEntityType.TEAM:
            case 7:
                return "TEAM";
            case KaggleEntityType.ORGANIZATION:
            case 8:
                return "ORGANIZATION";
        }
    }
};
export var PrivatedModerationStatus;
(function(PrivatedModerationStatus) {
    PrivatedModerationStatus["UNSPECIFIED"] = "unspecified";
    PrivatedModerationStatus["NO_ABUSE"] = "noAbuse";
    PrivatedModerationStatus["PRIVATED"] = "privated";
    PrivatedModerationStatus["PERMANENTLY_PRIVATED"] = "permanentlyPrivated";
})(PrivatedModerationStatus || (PrivatedModerationStatus = {}));
export var PrivatedModerationStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "PRIVATED_MODERATION_STATUS_UNSPECIFIED":
            default:
                return PrivatedModerationStatus.UNSPECIFIED;
            case "PRIVATED_MODERATION_STATUS_NO_ABUSE":
                return PrivatedModerationStatus.NO_ABUSE;
            case "PRIVATED_MODERATION_STATUS_PRIVATED":
                return PrivatedModerationStatus.PRIVATED;
            case "PERMANENTLY_PRIVATED":
                return PrivatedModerationStatus.PERMANENTLY_PRIVATED;
        }
    }
};
export var ReportedDismissalType;
(function(ReportedDismissalType) {
    ReportedDismissalType["UNSPECIFIED"] = "unspecified";
    ReportedDismissalType["BANNER"] = "banner";
    ReportedDismissalType["MODAL"] = "modal";
})(ReportedDismissalType || (ReportedDismissalType = {}));
export var ReportedDismissalTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ReportedDismissalType.UNSPECIFIED:
            case 0:
            default:
                return "REPORTED_DISMISSAL_TYPE_UNSPECIFIED";
            case ReportedDismissalType.BANNER:
            case 1:
                return "BANNER";
            case ReportedDismissalType.MODAL:
            case 2:
                return "MODAL";
        }
    }
};
export var abuseClient = {
    abuseService: {
        // An admin only method to allowlist an entity, marking it as no longer moderated automatically
        adminAllowlistEntity: createClient(AdminAllowlistEntityRequestWireFormat3, google.protobuf.EmptyWireFormat3, "abuse.AbuseService/AdminAllowlistEntity"),
        // Set dismissal state for a given entity (only applicable to notebooks / datasets)
        setReportedDismissal: createClient(SetReportedDismissalRequestWireFormat3, google.protobuf.EmptyWireFormat3, "abuse.AbuseService/SetReportedDismissal")
    }
};
